/**
 * IMPORTS
 */
import type { IFiltrosMinhaAgenda } from "@/interface/agenda-cliente";
import { agendaClienteRepository } from "@/repositories/agenda-cliente";

/*
 * Relança o erro: quem trata é o react-query (isError).
 */

const handleListarMinhaAgenda = (accessToken: string, filtros: IFiltrosMinhaAgenda) =>
  agendaClienteRepository.getListarMinhaAgenda(accessToken, filtros);

/**
 * EXPORTS
 */
export { handleListarMinhaAgenda };
